__turbopack_context__.v({
  "accordionItem": "cRh5nW_accordionItem",
  "navLink": "cRh5nW_navLink",
  "settingsBackLink": "cRh5nW_settingsBackLink",
});
